import { FC } from 'react';
import { BatteryBlock } from './BatteryBlock';
import { EmptyBatterySlot } from './EmptyBatterySlot';
import type { Battery } from '@/hooks/useBatteryContainers';

interface BatteryTypeSectionProps {
  title: string;
  batteries: Battery[];
  maxBatteries: number;
  size: 'single' | 'double';
  allocations?: Map<string, string>;
  onAllocate?: (battery: Battery) => void;
  onEdit?: (battery: Battery) => void;
  onDelete?: (battery: Battery) => void;
}

export const BatteryTypeSection: FC<BatteryTypeSectionProps> = ({
  title,
  batteries,
  maxBatteries,
  size,
  allocations,
  onAllocate,
  onEdit,
  onDelete,
}) => {
  const emptySlots = Math.max(0, maxBatteries - batteries.length);

  if (maxBatteries === 0) return null;

  return (
    <div className="space-y-2">
      <h4 className="text-sm font-medium text-muted-foreground">
        {title} ({batteries.length}/{maxBatteries})
      </h4>
      
      <div className="flex flex-wrap gap-2">
        {batteries.map((battery) => (
          <BatteryBlock
            key={battery.id}
            battery={battery}
            position={0}
            allocatedTo={allocations?.get(battery.id)}
            onAllocate={onAllocate ? () => onAllocate(battery) : undefined}
            onEdit={onEdit ? () => onEdit(battery) : undefined}
            onDelete={onDelete ? () => onDelete(battery) : undefined}
            isDouble={size === 'double'}
          />
        ))}
        
        {Array.from({ length: emptySlots }).map((_, idx) => (
          <EmptyBatterySlot key={`empty-${idx}`} size={size} />
        ))}
      </div>
    </div>
  );
};
